
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/newReleasesFeed/newReleasesFeed.scss.css.virtualfile';
        module.exports = {"container":"_container_1an6l_7"};